<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small"
            @change="getListData">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库单号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.outputStoreNo"
            placeholder="请输入出库单号"></el-input>
        </el-form-item>
        <el-form-item label="顾客名称：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerName"
            placeholder="请输入顾客名称"></el-input>
        </el-form-item>
        <el-form-item label="顾客手机号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerPhone"
            placeholder="请输入顾客手机号"></el-input>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.orderNo"
            placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="出库状态：">
          <el-select v-model.number="formInline.outputState" placeholder="请选择出库状态" size="small" @change="getListData">
            <el-option v-for="item in stateList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库时间：">
          <el-date-picker clearable v-model="dateValue" size="small" type="daterange" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd" @change="handleDateChange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button v-if="this.$checkBtnPermission('/outputStore/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/outputStore/index', 'reset')" size="small" icon="el-icon-refresh"
            @click="clearAll">重置</el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @rowClick="handleRowClick" border>
        <el-table-column align="center" slot="outputStoreNo" label="出库单号" width="250" fixed="left">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleClickOutputStoreNo(scope.row)">
              {{ scope.row.outputStoreNo }}
            </el-link>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 详情 -->
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import { GetOutputStorePageList } from "@/api/receiptApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "./detail.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "出库单列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      storeList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      stateList: [],
      dateValue: [],
      selectionList: [],
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        customerName: "",
        customerPhone: "",
        belongStoreKeyId: "",
        outputStoreNo: "",
        orderNo: "",
        startTime: null,
        endTime: null,
        outputState: 0,
      },
      columnsData: [], //显示列
      listColumns: [
        // {
        //   prop: "keyId",
        //   label: "全选",
        //   align: "center",
        //   fixed: "left",
        //   width: "55",
        //   isKeep: true,
        //   selection: true,
        // },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          slot: "outputStoreNo",
          label: "出库单号",
          align: "center",
          fixed: "left",
          width: "230",
          isKeep: true,
        },
        {
          prop: "belongStoreName",
          label: "所属门店",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "180",
        },
        {
          prop: "customerInfo.name",
          label: "顾客姓名",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "80",
        },
        {
          prop: "outputDate",
          label: "出库时间",
          align: "center",
          isKeep: true,
          width: "160",
        },
        {
          prop: "customerInfo.phone",
          label: "顾客手机号",
          align: "center",
          isKeep: true,
          width: "150",
        },
        {
          prop: "orderDate",
          label: "下单日期",
          align: "center",
          isKeep: true,
          width: "160",
        },
        {
          prop: "getOrderDate",
          label: "取镜日期",
          align: "center",
          width: "160",
        },
        {
          prop: "yanGuangShi",
          label: "验光师",
          align: "center",
          width: "80",
        },
        {
          prop: "jjInformation",
          label: "镜架信息",
          align: "center",
          minWidth: "120",
        },
        {
          prop: "machinTypeStr",
          label: "加工类型",
          align: "center",
          minWidth: "120",
        },
        {
          prop: "outputStateStr",
          label: "出库状态",
          align: "center",
          width: "100",
        },
        {
          prop: "orderNo",
          label: "订单号",
          align: "center",
          width: "220",
        },
        {
          prop: "creator",
          label: "创建人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "createTime",
          label: "创建时间",
          align: "center",
          minWidth: "160",
        },
        {
          prop: "editor",
          label: "维护人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          align: "center",
          minWidth: "160",
        },
      ],
    };
  },
  // 注册组件
  components: {
    detail,
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrganizationListByConfig();
    this.GetEnumConfigListByCode();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    handleDateChange(val) {
      if (val) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    //获取状态信息
    GetEnumConfigListByCode() {
      const paramer = {
        code: "OutputState",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.stateList = [];
            res.data.forEach((item) => {
              this.stateList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.stateList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    handleCommand(command) {
      // 1编辑
      switch (command.command) {
        case "4":
          this.deleteCustomer(command.rowData);
          break;
        default:
          console.log(command);
      }
    },
    // 单击行数据
    handleRowClick(row) {
      // this.$refs.edit.editShow(row);
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetOutputStorePageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 获取所属门店
    GetOrganizationListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrganizationListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 点击出库单号
    handleClickOutputStoreNo(row) {
      this.$refs.detail.showDetailDialog(row.keyId);
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>